import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do I choose a Flutter app development company?",
    answer: ` <p>Here’s How you can choose the best Flutter app development company for your project:</p>
    <ul>
    <li>Specify your business needs</li>
    <li>Establish your financial plan</li>
    <li>Evaluate their previous work</li>
    <li>Check feedback from clients</li>
    <li>Look for post-project assistance</li>
</ul>`,
  },
  {
    question: "Is Flutter good for app development?",
    answer: `<p>Flutter technology offers remarkable flexibility, enabling the creation of a diverse range of applications, catering to startups and enterprises alike. It is quite suitable for small-scale projects with fast application development and cost-effective delivery of the final product.</p>`,
  },
  {
    question: "How much does it cost to build a Flutter app?",
    answer: `<p>The common cost of developing a Flutter app varies between $15,000 and $200,000, depending on the project's scope. Meanwhile, several factors determine the overall expense of Flutter app development.</p> `,
  },
  {
    question: "Why Choose TekRevol for Flutter app development services?",
    answer: `<p>Choosing Tekrevol for Flutter app development services can be quite beneficial for your business as we have the expertise to build innovative Flutter apps. From consultation for discussing your idea to your app's design, development, and testing, we facilitate you at every step. </p> `,
  },
  {
    question:
      "Does TekRevol offer complete support and maintenance after the Flutter app development?",
    answer: `<p>Yes, TekRevol always serves its clients with dedication even after the completion of their project. That’s how you can ensure the optimal performance of your app by using our committed support and maintenance for your Flutter app.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
